export const CLIENTS = 'clients_modal'

export const clients = {
  en: {
    translation: {
      [CLIENTS]: {
        // Clients Table
        clientOverview: 'Client Overview',
        businessName: 'Business Name',
        accountPayable: 'Account Payable',
        newClient: 'New Client',
        phone: 'Phone',
        // Client Modal
        name: 'Name',
        paymentTerms: 'Payment Terms',
        paymentMethod: 'Payment Method',
        accPayConInfo: 'Accounts Payable Contact Details',
        creditCard: 'Credit Card',
        check: 'Check',
        ach: 'ACH',
        wired: 'Wired',
        ext: 'Ext',
        address: 'Address',
        city: 'City',
        state: 'State',
        zipCode: 'Zip Code',
        contact: 'Contact',
        phoneNumber: 'Phone Number',
        email: 'Email',
        market: 'Market',
        addContact: 'Add Contact',
        comment: 'Comment',
        cancel: 'Cancel',
        save: 'Save',
        next: 'Next',
        enterNewNote: 'Enter New Note Here',
        newClientDetails: 'New Client Details',
        newClientMsg: 'New client has been added successfully.',
        updateClientDetails: 'Update Client Details',
        updateClientMsg: 'Client has been added successfully.',
        clientNTE: 'NTE Amount',
        billingRate: "General Hourly Rate",
        licensedHourlyRate: "Licensed Hourly Rate",
        abbreviation: 'Abbreviation',
      },
    },
  },
  es: {
    translation: {
      [CLIENTS]: {
        // Client Table
        clientOverview: 'Descripción general del cliente',
        businessName: 'Nombre del Negocio',
        accountPayable: 'Cuenta por pagar',
        newClient: 'Nuevo cliente',
        phone: 'Teléfono',
        // Client Modal
        name: 'Nombre',
        paymentTerms: 'Términos de pago',
        paymentMethod: 'Método de pago',
        accPayConInfo: 'Datos de contacto de cuentas por pagar',
        creditCard: 'Crédito',
        check: 'Controlar',
        ach: 'ACH',
        wired: 'Transferencia',
        ext: 'Ext',
        address: 'Dirección',
        city: 'Ciudad',
        state: 'Estado',
        zipCode: 'Código postal',
        contact: 'Contacto',
        phoneNumber: 'Número de teléfono',
        email: 'Correo electrónico',
        market: 'Mercado',
        addContact: 'Agregar contacto',
        comment: 'Comentario',
        cancel: 'Cancelar',
        save: 'Ahorrar',
        next: 'Siguiente',
        enterNewNote: 'Ingrese una nueva nota aquí',
        newClientDetails: 'Detalles del nuevo cliente',
        newClientMsg: 'El nuevo cliente se ha agregado con éxito.',
        updateClientDetails: 'Actualizar los detalles del cliente',
        updateClientMsg: 'El cliente se ha agregado con éxito.',
        clientNTE: 'NTE Amount',
        billingRate: "General Hourly Rate",
        licensedHourlyRate: "Tarifa por hora con licencia",
        abbreviation: 'Abreviatura',
      },
    },
  },
}
